import React from 'react'

const DoneIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <path d="M19.623 11.5802C19.623 6.65682 15.6318 2.66565 10.7085 2.66565C5.78511 2.66565 1.79395 6.65682 1.79395 11.5802C1.79395 16.5035 5.78511 20.4947 10.7085 20.4947C15.6318 20.4947 19.623 16.5035 19.623 11.5802Z" fill="#34A853" stroke="#34A853" stroke-width="1.00288" />
            <path d="M7.14258 12.2488C7.14258 12.2488 8.5689 13.0623 9.28206 14.2546C9.28206 14.2546 11.4216 9.57445 14.2742 8.0144" stroke="white" stroke-width="1.00288" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default DoneIcon;